<template>
    <div>
        <div class="panel-body">
            <div class="user-pc-builds m-l m-t">
                <div class="builds-tables">
                    <div class="table-responsive">
                        <div id="no-more-tables">
                            <template v-if="tickets.length && !loadingTickets">
                                <div v-for="ticket in tickets" class="ticket-wrapper clearfix text-white">
                                    <div class="col-md-8 col-xs-5 ticket-number">
                                        <div class="col-md-3 col-xs-12 ticket-number">{{ticket.id}}</div>
                                        <div class="col-md-5 col-xs-12 ticket-number-date">
                                            {{ ticket.subject }}
                                        </div>
                                        <div class="col-md-4 col-xs-12 ticket-number-date">
                                            {{ ticket.created_at | relativeDate }}
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-xs-7 text-right">
                                        <router-link :to="'/users/tickets/show/'+ticket.id"
                                            class="btn btn-sm btn-round btn-green">
                                            {{ ticket.status }}
                                            <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                                        </router-link>
                                    </div>
                                    <div class="clearfix"></div>
                                    <hr>
                                </div>

                            </template>
                            <template v-if="!tickets.length && !loadingTickets">
                                <div class="text-center">
                                    <h4 class="text-white m-b-md">
                                        You have not created a ticket from LETSBLD.com yet!
                                        <br>
                                        <a @click="createTicket()">CLICK HERE</a>
                                        to Create a Ticket.
                                    </h4>
                                </div>
                            </template>
                            <template v-if="loadingTickets">
                                <div style="color: white" class="text-center">
                                    <span class="fa fa-spin fa-spinner"></span>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "tickets",
        data() {
            return {
                loadingTickets: true,
                tickets: [],
                selectedTicket: {}
            }
        },
        props: {
            reloadTickets: {
                type: Boolean
            }
        },
        watch: {
           reloadTickets() {
              this.getTickets();
              this.$emit("ticketsLoaded");
           }
        },
        created() {
            this.getTickets();
        },
        methods: {
            createTicket() {
                this.$emit("createTicket");
            },
            getTickets() {
                this.loadingTickets = true;
                axios({
                    url: "/tickets",
                    method: "GET"
                }).then(tickets => {
                    this.tickets = tickets.data.tickets;
                    this.loadingTickets = false;
                }).catch(error => {
                    this.loadingTickets = false;
                    toastr.error(error);
                })
            }
        }
    }
</script>

<style scoped lang="scss">
@import '~@s/_asset-mixers.scss';
.blue-btn {
    background-color: $purple;
    text-transform: uppercase;
    display: inline-block;
    width: 100%;
    text-align: center;
    color: #000;
    letter-spacing: 2px;
    border: none;
    border-radius: 25px;
    padding: 10px 10px;
    transition: all 0.4s ease;
    font-size: 12px;
    line-height: 20px;
    padding: 5px 0;
    width: 158px;
}

.order-wrapper {
    border-bottom: 1px solid #fff;
    padding: 10px 0;
}

.builds-tables {
    max-height: 470px;
    padding-right: 20px;
    overflow: overlay;
    font-size: 18px;
}
</style>
